import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import SpinnerBlock from 'components/others/SpinnerBlock';
import { OffDocumentPayments } from 'modules/objects';
import { usePaymentReport } from './context/ReportObjectPaymentsProvider';
import ReportObjectPaymentsToolBar from './ReportObjectPaymentsToolBar';
import ReportObjectPaymentsTable from './ReportObjectPaymentsTable';
import ReportObjectPaymentsGroup from './ReportObjectPaymentsGroup';
import ReportObjectPaymentsTotals from './ReportObjectPaymentsTotals';

const ReportObjectPayments = () => {
    const { t } = useTranslation(['Reports', 'common']);
    const report = usePaymentReport();
    if (!report.allowed) return <div className="text-danger">{t('objectPayments.forbidden')}</div>;
    return (
        <Row className="object-payments-report">
            <Col className={report.objectId === undefined ? 'col-sticky' : undefined} sm={12}>
                <div className={`w-100 d-sm-flex flex-wrap pt-1 ${report.objectId === undefined ? 'justify-content-between' : 'justify-content-end'} align-items-start gap-2`}>
                    {report.objectId === undefined && <h4 className="p-0 m-0 me-2 text-break">{t('objectPayments.title')}</h4>}
                    <ReportObjectPaymentsToolBar /> 
                </div>
            </Col>
            <Col sm={12}>
                {report.error && <div className="alert alert-danger d-flex align-items-center justify-content-between" role="alert">
                    {t('common:messError')}
                    <Button size="sm" variant="outline-danger" onClick={report.retry}>{t('objectPayments.retry')}</Button>
                </div>}
                {report.payments === null ? <ESpinner /> : (
                    <div className="position-relative">
                        <SpinnerBlock onlyBlur={true} show={report.isReporting || report.documentLoading} />
                        {report.filters.detail && report.groups.length ? <>
                            {report.groups.map((group) => <ReportObjectPaymentsGroup key={group.id} group={group} />)}
                            <div className="mb-3"><ReportObjectPaymentsTotals rows={report.rows} label={t('objectPayments.total')} /></div>
                        </> : <ReportObjectPaymentsTable rows={report.rows} />}
                    </div>
                )}
            </Col>
            <OffDocumentPayments readOnly objectId={report.documentTarget?.row.objectId || 0} showTarget={report.documentTarget} setShowTarget={report.setDocumentTarget} />
        </Row>
    );
};

export default ReportObjectPayments;
